import { Filters, Paginate, ProjectsList } from "../components";

import styled from "styled-components";
import { useGlobaleContext } from "../context";

const ProjectsPage = () => {
  const { toggleHoverAnimation } = useGlobaleContext();

  return (
    <Wrapper>
      <div className="projects--header">
        <h1 className="font-face-js section-heading">
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            P
          </span>
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            r
          </span>
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            o
          </span>
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            j
          </span>
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            e
          </span>
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            c
          </span>
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            t
          </span>
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            s
          </span>
        </h1>
        <Filters />
        <Paginate />
      </div>

      <ProjectsList />
    </Wrapper>
  );
};

const Wrapper = styled.main`
  flex-direction: column;
  row-gap: 0rem;
  margin-top: 0;
  .section-heading {
    font-size: 49px !important;
    line-height: 6rem !important;
    width: max-content;
    margin: 0 !important;
    padding: 0 !important;
  }

  .projects--header {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top: 0;
  }
  @media (max-width: 1366px) {
    .projects--header {
      margin-top: 0;
      margin-bottom: 5vh;
    }
  }
  @media (max-width: 992px) {
    .projects--header {
      flex-direction: column;
      align-items: self-start;
      row-gap: 2vh;
      padding-left: 1vh;
      margin-bottom: 0;
    }
  }

  @media (max-width: 635px) {
    & {
      margin-top: 3vh;
    }
  }
`;
export default ProjectsPage;
